/**
 * Collection intro accordion — EazzyWalls
 *
 * Mobile (<=768px): clamps the collection description and shows a
 * "Show more" / "Show less" button.
 * Desktop: does nothing — the description renders in full, button stays hidden.
 *
 * The button is only shown when the text is actually taller than the clamp,
 * so short descriptions do not get a pointless toggle.
 */
(() => {
  const intro  = document.querySelector('[data-collection-intro]');
  const toggle = document.querySelector('[data-collection-intro-toggle]');
  if (!intro || !toggle) return;

  const mq = window.matchMedia('(max-width: 768px)');

  function isOverflowing() {
    // measure against the clamped height without flashing the user
    const wasOpen = intro.classList.contains('is-open');
    intro.classList.add('is-clamped');
    intro.classList.remove('is-open');

    const overflows = intro.scrollHeight > intro.clientHeight + 4;

    if (wasOpen) {
      intro.classList.add('is-open');
      intro.classList.remove('is-clamped');
    }
    return overflows;
  }

  function sync() {
    if (!mq.matches) {
      // desktop — full text, no button
      intro.classList.remove('is-clamped', 'is-open');
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Show more';
      return;
    }

    // mobile
    if (!isOverflowing()) {
      intro.classList.remove('is-clamped', 'is-open');
      toggle.hidden = true;
      return;
    }

    toggle.hidden = false;
    if (!intro.classList.contains('is-open')) {
      intro.classList.add('is-clamped');
    }
  }

  toggle.addEventListener('click', () => {
    const open = !intro.classList.contains('is-open');
    intro.classList.toggle('is-open', open);
    intro.classList.toggle('is-clamped', !open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.textContent = open ? 'Show less' : 'Show more';
  });

  sync();
  mq.addEventListener('change', sync);
  window.addEventListener('load', sync);
})();